import { render, staticRenderFns } from "./BookInfoDialog.vue?vue&type=template&id=5c51527b&"
import script from "./BookInfoDialog.vue?vue&type=script&lang=js&"
export * from "./BookInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports